module.exports = __webpack_public_path__ + "static/slide-4-8df9e8c6268658289e17280b58613e76.png";